export var visibleObserver = function (visibleCallback) {
    // in a mobile app.
    var mraid = window.mraid;
    if (mraid) {
        var listen_1 = function () {
            return mraid.addEventListener('viewableChange', visibleCallback);
        };
        if (mraid.getState() === 'loading') {
            var onReady_1 = function () {
                listen_1();
                mraid.removeEventListener('ready', onReady_1);
            };
            mraid.addEventListener('ready', onReady_1);
        }
        else {
            listen_1();
        }
        return;
    }
    // In a browser, not a mobile app.
    var callback = function (entries) {
        entries.forEach(function (entry) {
            visibleCallback(entry.isIntersecting);
        });
    };
    // headless browsers or IE might not have this feature.
    if (IntersectionObserver) {
        new IntersectionObserver(callback, {
            threshold: 0.5,
        }).observe(document.querySelector('#root'));
    }
    else {
        visibleCallback(true);
    }
};
